module.exports = __webpack_public_path__ + "img/placeholder/gallery/selah-sue-montreux-jazz-lab-2014-portrait.jpg";